import { useThree } from '@react-three/fiber';
import  { useCallback, useState } from 'react'

function useCameraAnimation() {
  const { camera } = useThree();
  const [isAnimating, setIsAnimating] = useState(false);
  
  const animateToPosition = useCallback((targetPosition, targetLookAt, duration = 2000) => {
    if (isAnimating) return;
    
    setIsAnimating(true);
    const startPosition = camera.position.clone();
    const startTime = Date.now();
    
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 3); 
      
      camera.position.lerpVectors(startPosition, targetPosition, easeProgress);
      camera.lookAt(targetLookAt);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setIsAnimating(false);
      }
    };
    
    animate();
  }, [camera, isAnimating]);
  
  return { animateToPosition, isAnimating };
}

export default useCameraAnimation